/**
 * 
 */
let { Control, TileLayer, Map } = L;
let { assign: $assign } = T;
/**
 * 
 */
export var Coordinates = Control.extend({
  options: {
    position: 'bottomleft'
  },
  onAdd(map) {
    let container = T.create('span');
    let showing = latlng => {
      container.innerText = "坐标：" + latlng.lng.toFixed(4) + ", " + latlng.lat.toFixed(4);
    }
    showing(map.getCenter())
    map.on('mousemove', e => {
      showing(e.latlng);
    })
    return container;
  },
});
/**
 * 
 */
export var HawkeyeMap = Control.extend({
  options: {
    position: 'topright',
  },
  onAdd(map) {
    let container = T.div();
    T(container).setStyle({
      position: 'relative',
      width: '200px',
      height: '200px',
      border: '2px solid #3D6DCC',
      borderRadius: '100px'
    })
    T.defer(() => {
      this.createHawkeyeMap(container);
    })
    return container;
  },

  /**
  * 创建鹰眼图
  */
  createHawkeyeMap(node, options) {
    let { _map: map } = this;
    let hawkeyeMap = new Map(node, $assign({}, map.options, {
      attributionControl: false,
      zoomControl: false,
      scrollWheelZoom: false,
    }));
    // hawkeyeMap.dragging.disable();
    hawkeyeMap.touchZoom.disable();
    hawkeyeMap.doubleClickZoom.disable();
    hawkeyeMap.scrollWheelZoom.disable();
    //
    let syncView = (e) => {
      hawkeyeMap.setView(map.getCenter(), map.getZoom() - 2);
    },
      syncLayer = (e) => {
        e && hawkeyeMap.eachLayer(layer => {
          hawkeyeMap.removeLayer(layer);
        })
        map.eachLayer(layer => {
          if (layer instanceof TileLayer) {
            new TileLayer((layer)._url, $assign({}, layer.options)).addTo(hawkeyeMap);
          }
        })
      }
    syncLayer();
    map.whenReady(syncView);
    map.on('move', syncView);
    hawkeyeMap.on('dragend', () => {
      map.panTo(hawkeyeMap.getCenter(), { animate: false });
    })
    // todo 修改
    T.vm.map.on('provider-change', syncLayer)//
    //
    return hawkeyeMap;
  }
});


// WEBPACK FOOTER //
// ./src/plugins/Widgets.js